import { CovanceFilterModule } from './../../covance-filter/covance-filter.module';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared';
import { AdminActivityReportsComponent } from './admin-activity-reports.component';
import { AdminActivityReportDocumentsComponent } from './documents/admin-activity-report-documents.component';
import { AdminProtocolAccessReportComponent } from './protocol-accesses/admin-protocol-access-reports.component';
import { CovanceAgGridModule } from '../../covance-ag-grid/covance-ag-grid.module';
import { DocumentsModule } from '../../documents/documents.module';
import { AdminActivityReportDocumentsStorage } from './documents/admin-activity-report-documents-storage';
import { AdminActivityReportFilterItemsStorage } from './documents/admin-activity-report-filter-items-storage';
import { AdminProtocolAccessesStorage } from './protocol-accesses/admin-protocol-accesses-storage';
import { AdminSharedModule } from '../admin-shared.module';
import { AdminActivityReportsDocumentsColumns } from './documents/admin-activity-reports-documents-columns';
import { AdminAccessInvestigationReportsComponent } from './access-investigation/admin-access-investigation-reports.component';
import { AdminActivityReportsFilterResolver } from './documents/admin-activity-reports-filter-resolver';
import { AdminAccessInvestigationsStorage } from './access-investigation/admin-access-investigations-storage';
import { ReactiveFormsModule } from '@angular/forms';
import { AdminProtocolAccessSearchFieldsStorage } from './protocol-accesses/admin-protocol-access-search-fields-storage';
import { AdminProtocolAccessFilterComponent } from './protocol-accesses/admin-protocol-access-filter/admin-protocol-access-filter.component';
import { AdminEmailAlertsStorage } from './email-alerts/admin-email-alerts-storage';
import { AdminEmailNotificationAlertsComponent } from './email-alerts/admin-email-notification-alerts-reports.component';

@NgModule({
    declarations: [
        AdminActivityReportsComponent,
        AdminActivityReportDocumentsComponent,
        AdminProtocolAccessReportComponent,
        AdminAccessInvestigationReportsComponent,
        AdminProtocolAccessFilterComponent,
        AdminEmailNotificationAlertsComponent,
    ],
    imports: [
        SharedModule,
        CovanceFilterModule,
        CovanceAgGridModule,
        DocumentsModule,
        ReactiveFormsModule,
        AdminSharedModule
    ],
    providers: [
        AdminAccessInvestigationsStorage,
        AdminActivityReportDocumentsStorage,
        AdminActivityReportFilterItemsStorage,
        AdminActivityReportsFilterResolver,
        AdminProtocolAccessesStorage,
        AdminActivityReportsDocumentsColumns,
        AdminProtocolAccessSearchFieldsStorage,
        AdminEmailAlertsStorage,
    ]
})
export class AdminActivityReportsModule { }